import * as React from 'react';

const PALETTE = [
  'bg-amber-100 text-amber-800',
  'bg-sky-100 text-sky-800',
  'bg-emerald-100 text-emerald-800',
  'bg-violet-100 text-violet-800',
  'bg-rose-100 text-rose-800',
  'bg-teal-100 text-teal-800',
];

function initials(name: string) {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  const letters =
    words.length === 1 ? words[0].slice(0, 2) : words[0][0] + words[words.length - 1][0];
  return letters.toUpperCase();
}

function tint(name: string) {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

interface Props {
  name: string;
  photoUrl?: string | null;
  className?: string;
  testId?: string;
}

export default function PersonAvatar({
  name,
  photoUrl,
  className = 'h-9 w-9',
  testId,
}: Props) {
  const [broken, setBroken] = React.useState(false);

  React.useEffect(() => setBroken(false), [photoUrl]);

  if (photoUrl && !broken) {
    return (
      <img
        src={photoUrl}
        alt=""
        onError={() => setBroken(true)}
        className={`${className} shrink-0 rounded-full border object-cover`}
        data-testid={testId ?? 'person-avatar-photo'}
      />
    );
  }

  return (
    <span
      aria-hidden
      className={`${className} shrink-0 select-none rounded-full ${tint(name)} flex items-center justify-center text-[11px] font-semibold`}
      data-testid={testId ? `${testId}-initials` : 'person-avatar-initials'}
    >
      {initials(name)}
    </span>
  );
}
